export const standardColours = {
  black: '#000',
  darkestGrey: '#1F1F1F',
  darkerGrey: '#797979',
  darkGrey: '#9C9C9C',
  grey: '#B6B6B6',
  lightGrey: '#EAEAEA',
  lighterGrey: '#F3F3F3',
  lightestGrey: '#F7F7F7',
  white: '#FFF',
  transparentBlack: value => {
    return `rgba(0, 0, 0, ${value})`;
  },
  transparentWhite: value => {
    return `rgba(255, 255, 255, ${value})`;
  },
  transparent: 'rgba(255, 255, 255, 0)',
};

export const brandColours = {
  primary: '#032491', // blue
  secondary: '#FF5A2C', // orange
  tertiary: '#F1F5FC', // light greyish blue
  quaternary: '#031D72', // dark blue
  quinary: '#0D183C', // darker blue
  senary: '#C0E45E', // light green
  septenary: '#CFEDEC', // light blue
  octonary: '#9BC319', // dark green
  nonary: '#FF483E', // red
  denary: '#FEEEAB', // light orange
};

export const elementColours = {
  textColour: standardColours.darkestGrey,
};
